import {
  MetadataFieldRelationByIntegrationType,
  MetadataFieldRelationValueByType,
} from '@modules/integrationsV2/store/types';
import { EqlField, FieldRelation, IntegrationType } from 'generated/graphql';

interface GetIntegrationMetadataFieldRelationsByTypeParams {
  fieldRelations: FieldRelation[];
  allEqlFields: EqlField[];
}

export const getMetadataFieldRelationsByIntegrationType = ({
  fieldRelations,
  allEqlFields,
}: GetIntegrationMetadataFieldRelationsByTypeParams): MetadataFieldRelationByIntegrationType[] => {
  if (!fieldRelations.length || !allEqlFields.length) {
    return [];
  }

  const fieldRelationsByType: MetadataFieldRelationByIntegrationType[] = [];

  fieldRelations.forEach((fieldRelation) => {
    const field1 = allEqlFields.find(
      (eqlField) => eqlField.field === fieldRelation.field1,
    );
    const field2 = allEqlFields.find(
      (eqlField) => eqlField.field === fieldRelation.field2,
    );

    if (field1 && field2) {
      const relationByType: MetadataFieldRelationByIntegrationType = {
        [IntegrationType.Feedback]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.Feedback,
        }),
        [IntegrationType.User]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.User,
        }),
        [IntegrationType.Account]: getFieldRelationsValueByType({
          field1,
          field2,
          integrationType: IntegrationType.Account,
        }),
        [IntegrationType.Cohorts]: null, // TODO: Add when cohort type is added to ObjectType
        [IntegrationType.Comms]: null, // Not supported, adding here to avoid type errors
      };

      fieldRelationsByType.push(relationByType);
    }
  });

  return fieldRelationsByType;
};

const getFieldRelationsValueByType = ({
  field1,
  field2,
  integrationType,
}: {
  field1: EqlField;
  field2: EqlField;
  integrationType: IntegrationType;
}): MetadataFieldRelationValueByType | null => {
  const fieldByType =
    field1.objectType.toString() === integrationType.toString()
      ? field1
      : field2.objectType.toString() === integrationType.toString()
      ? field2
      : null;

  if (!fieldByType) {
    return null;
  }

  return {
    field: fieldByType.field,
    source: fieldByType.detail?.metadata?.source ?? '',
  };
};
